import type { IntlShape } from 'react-intl';

import { aiSuggestionsMessages } from '@atlaskit/editor-common/ai-messages';

/**
 * Returns the domain-specific rotating messages shown while the AI
 * suggestions thinking bar is active.
 */
export function getThinkingRotatingMessages(formatMessage: IntlShape['formatMessage']): string[] {
	return [
		formatMessage(aiSuggestionsMessages.thinkingReviewingContent),
		formatMessage(aiSuggestionsMessages.thinkingMayTakeAFewMinutes),
		formatMessage(aiSuggestionsMessages.thinkingAnalyzingStructure),
		formatMessage(aiSuggestionsMessages.thinkingCheckingRelatedSources),
		formatMessage(aiSuggestionsMessages.thinkingGatheringContext),
		formatMessage(aiSuggestionsMessages.thinkingIdentifyingImprovements),
		formatMessage(aiSuggestionsMessages.thinkingEvaluatingOptions),
		formatMessage(aiSuggestionsMessages.thinkingCheckingConsistency),
		formatMessage(aiSuggestionsMessages.thinkingPreparingSuggestions),
		formatMessage(aiSuggestionsMessages.thinkingRefiningSuggestions),
		formatMessage(aiSuggestionsMessages.thinkingFinalizingSuggestionsForReview),
	];
}
